import { render } from "./opEditable.vue?vue&type=template&id=3e4b0ba0&scoped=true&ts=true"
import script from "./opEditable.vue?vue&type=script&lang=ts"
export * from "./opEditable.vue?vue&type=script&lang=ts"

import "./opEditable.vue?vue&type=style&index=0&id=3e4b0ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4b0ba0"]])

export default __exports__